document.addEventListener('DOMContentLoaded', function () {
  var logoWrapper = document.querySelector('.header__heading-logo-wrapper');
  if (!logoWrapper) return;

  window.addEventListener('scroll', function () {
    if (window.innerWidth > 767) {
      if (window.scrollY > 50) {
        logoWrapper.classList.add('shrink');
      } else {
        logoWrapper.classList.remove('shrink');
      }
    } else {
      logoWrapper.classList.remove('shrink');
    }
  });
});
